<button mat-stroked-button [matMenuTriggerFor]="interval" class="btn-md justify-between items-center rounded shadow-none  text-gray-500 max-h-full w-full"
  [style.height.px]="height">
  <span>
    <span *ngIf="selectedDate" class="mx-2">{{selectedDate}}</span>
    <span *ngIf="customDateRange" class="ml-2">{{customDateRange.from}}&nbsp;-&nbsp;{{customDateRange.to}}</span>
  </span>
  <span class="ml-2">
    <mat-icon svgIcon="arrow_drop_down"></mat-icon>
  </span>
</button>

<mat-menu #interval="matMenu">
  <button *ngIf="isTodayDateEnabled" mat-menu-item (click)="setDate(dateInterval.TODAY)">Today</button>
  <button mat-menu-item (click)="setDate(dateInterval.WEEK)">Week</button>
  <button mat-menu-item (click)="setDate(dateInterval.MONTH)">Month</button>
  <button mat-menu-item (click)="setDate(dateInterval.QUARTER)">Quarter</button>
  <button mat-menu-item (click)="setDate(dateInterval.YEAR)">Year</button>
  <button mat-menu-item (click)="setDate(dateInterval.TOTAL)">Total</button>
  <button *ngIf="isCustomDateEnabled" mat-menu-item (click)="openIntervalDialog()">Custom Range</button>
</mat-menu>
